export default __webpack_public_path__ + "assets/icon-ascending-sort.e2f9d684.webp";